import { useState, useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";
import { isBefore } from "date-fns";
import {
  Card,
  Typography,
  Link,
  CardHeader,
  Avatar,
  CardContent,
  CardActions,
  Box,
  CircularProgress,
} from "@common-ui/ui";
import HistoryIcon from "@mui/icons-material/History";
import { RecentWorkList } from "../../components/List/RecentWorkList";

export const RecentWorks = ({ workEvents, orgId }) => {
  const [isLoading, setIsLoading] = useState(false);

  const [recentWorkEvents, setRecentWorkEvents] = useState([]);

  useEffect(() => {
    setIsLoading(true);

    let todayDate = new Date().setHours(0, 0, 0, 0);
    const recentWork = workEvents.filter((workevent) => {
      let scheduledStart = new Date(workevent.scheduled_start_date);
      scheduledStart.setHours(0, 0, 0, 0);
      return isBefore(scheduledStart, todayDate);
    });

    if (recentWork.length > 0) {
      // Sort by descending: would mean that the most recent ones come first and the oldest ones last..
      recentWork.sort(function compare(a, b) {
        var dateA = new Date(a.scheduled_start_date);
        var dateB = new Date(b.scheduled_start_date);
        return dateB - dateA;
      });
      setRecentWorkEvents(recentWork);
      setIsLoading(false);
    } else {
      setRecentWorkEvents([]);
      setIsLoading(false);
    }
  }, [workEvents]);

  return (
    <Card
      variant="outlined"
      sx={{ height: "100%", display: "flex", flexDirection: "column" }}
    >
      <CardHeader
        avatar={
          <Avatar aria-label="actions" sx={{ width: 56, height: 56 }}>
            <HistoryIcon />
          </Avatar>
        }
        title={<Typography variant="h4">Recent Work</Typography>}
      />
      {recentWorkEvents?.length > 0 ? (
        <CardContent>
          <RecentWorkList recentWorkEvents={recentWorkEvents} orgId={orgId} />
        </CardContent>
      ) : isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          No Work Events Found
        </Box>
      )}

      <CardActions
        disableSpacing
        sx={{ pb: 3, pr: 3, mt: "auto" }}
        style={{ justifyContent: "right" }}
      >
        <Link
          component={RouterLink}
          to="/work-events"
          style={{ cursor: "pointer" }}
        >
          View All Work
        </Link>
      </CardActions>
    </Card>
  );
};
